import { BaseClickHandler } from './base-click-handler.util.ts';

export class CapitalLetterUtil extends BaseClickHandler<string, string> {
  private static _instance: CapitalLetterUtil;

  public static get instance(): CapitalLetterUtil {
    if (!CapitalLetterUtil._instance) {
      CapitalLetterUtil._instance = new CapitalLetterUtil();
    }
    return CapitalLetterUtil._instance;
  }

  protected override processInput(letter: string): string {
    return letter;
  }
}

export const getCapitalLetterUtil = (): CapitalLetterUtil => CapitalLetterUtil.instance;
